import { Component, HostBinding, Input, OnInit } from '@angular/core';

export class CustomSelectItem {
    name: string;
    level: number;
    icon: string;
    iconColor: string;
    iconColorDisabled: string;
    iconSecond: string;
    iconSecondColor: string;
    iconUrl: string;
    iconUrlSelected: string;
    type: string;
    data: any;

    constructor(value: Partial<CustomSelectItem>) {
        Object.assign(this, value);
    }
}

@Component({
    standalone: false,
    selector: 'res-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent implements OnInit {
    @HostBinding('class') classes;

    @Input() items: Array<CustomSelectItem>;
    @Input() selectedItem: CustomSelectItem;
    @Input() disabled: boolean;
    @Input() onSelectionChanged: (item: CustomSelectItem) => void;

    @Input() customClass: string;
    @Input() optionHeight = 30;
    @Input() automationId: string;

    ngOnInit(): void {
        if (this.customClass) {
            this.classes = this.customClass;
        }
    }

    selectItem(item: CustomSelectItem): void {
        this.selectedItem = item;
        if (this.onSelectionChanged) {
            this.onSelectionChanged(this.selectedItem);
        }
    }
}
